import { FC } from 'react';
import { Theme, Typography } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    important: {
      color: theme.palette.secondary.main,
    },
    success: {
      color: theme.palette.success.main,
    },
    error: {
      color: theme.palette.error.main,
    },
    default: {
      color: theme.palette.secondary.contrastText,
    },
  })
);

export const LabelTypography: FC<{ text: string; type: string }> = ({ text, type }) => {
  const classes: any = useStyles();
  return (
    <Typography variant="body2" component="span" className={classes[type]}>
      {text}
    </Typography>
  );
};
